export const hasPdfExtension = (filename: string) => {
  return /\.pdf$/i.test(filename);
};

export function formatPrettyDate(
  dateString: string,
  locale = "lt-LT",
  showTime = false
): string {
  try {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };
    if (showTime) {
      options.hour = "2-digit";
      options.minute = "2-digit";
      options.second = "2-digit";
    }
    const parts = new Intl.DateTimeFormat(locale, options).formatToParts(date);
    const year = parts.find((p) => p.type === "year")?.value;
    const month = parts.find((p) => p.type === "month")?.value;
    const day = parts.find((p) => p.type === "day")?.value;
    const hour = parts.find((p) => p.type === "hour")?.value;
    const minute = parts.find((p) => p.type === "minute")?.value;
    const second = parts.find((p) => p.type === "second")?.value;

    const formattedDate = `${year}-${month}-${day}`;
    const formattedTime = showTime ? ` ${hour}:${minute}:${second}` : "";

    return `${formattedDate}${formattedTime}`;
  } catch (e) {
    console.warn(e);
    return "-";
  }
}

export const getZoneColor = (zoneValue: string): string => {
  switch (zoneValue) {
    case "A":
      return "#FFFF00"; // Yellow
    case "B":
      return "#808000"; // Olive
    case "C":
      return "#feca57"; // Orange
    case "D":
      return "#45b7d1"; // Blue
    case "E":
      return "#FF0000"; // Red
    default:
      return "#f0f0f0";
  }
};

export const getTextColor = (backgroundColor: string): string => {
  const hex = backgroundColor.replace("#", "");

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  return luminance > 0.5 ? "#000000" : "#FFFFFF";
};

// --- direction (UPLOAD / UNLOAD) -------------------------------------------
// The action names stored in the database are shared between both directions
// ('start_uploading' and friends), so the UI translates them per direction:
// "<action>_unload" when such a key exists, otherwise the shared key.
export const isUnloadType = (type?: string): boolean =>
  String(type || "").toUpperCase() === "UNLOAD";

export const directionKey = (base: string, type?: string): string =>
  isUnloadType(type) ? `${base}_unload` : base;

export const directionBadge = (type?: string): string => {
  const unload = isUnloadType(type);
  const bg = unload ? "#DCEBED" : "#F7EBD6";
  const fg = unload ? "#125A66" : "#B36B00";
  const label = unload ? "IŠKR" : "PAKR";
  return `<span style="display:inline-block;padding:2px 7px;border-radius:3px;` +
    `font-size:11px;font-weight:600;letter-spacing:.04em;background:${bg};color:${fg}">${label}</span>`;
};
